import yup from "src/utils/yup/extensionMethods";

const selecUserSchema = yup.object().shape({
	mea008Efa004Id: yup.string().nullable(),
	mea008Efa005Id: yup.string().nullable(),
	mea008Permissao: yup.number()
});

const deleteSchemaMap = (translate: Function) => yup.object().shape({
	mea001Nome: yup.string().required(translate("Nome do mapa não confere")).oneOf([yup.ref("mea001NomeConfirmation")], translate("Nome do mapa não confere"))
});

const addAndChangeSchemaMap = (translate: Function) => yup.object().shape({
	mea001Nome: yup.string().required(translate("Nome é requerido")).max(100, translate("Título deve conter no máximo 100 caracteres")),
	mea001Dtvalini: yup.date().nullable().required(translate("Data Inicial é requerida")),
	mea001Dtvalfim: yup.date().nullable().required(translate("Data Final é requerida")).min(
		yup.ref("mea001Dtvalini"),
		translate("Data Final tem que ser após a Data Inicial")
	),
	mea001Descricao: yup.string().required(translate("Descrição é requerida")),
	mea001Missao: yup.string().required(translate("Missão é requerida")),
	mea001Visao: yup.string().required(translate("Visão é requerida")),
	metba008: yup.array().of(selecUserSchema.required("Necessário informar Campo"))
		.unique(translate("Usuários não podem ser repetidos"), (a: any) => a.mea008Efa005Id, (a: any) => !a.mea008Efa004Id)
		.unique(translate("Grupo de Usuários não podem ser repetidos"), (a: any) => a.mea008Efa004Id, (a: any) => !a.mea008Efa005Id)
});

export { deleteSchemaMap, addAndChangeSchemaMap };
